import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import TiposFinalizacaoSearchForm from './search-form.js'

const EventTypeSearchModel = {
  data: null
}

export default {
  mixins: [ActionsForm],
  name: 'EventTypeSearch',
  data () {
    return {
      data: EventTypeSearchModel,
      form: TiposFinalizacaoSearchForm
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  methods: {
    onLoad () {
      this.onClearFilters()
    },
    onClearFilters () {
      Tools.SetFormDefaultValues(this.form)
      this.parentComponent.filters = null
      this.parentComponent.onLoadAll()
    },
    onValidateFilters () {
      let result = true
      Tools.SetValueToSave(this.form, this.data)
      return result
    },
    onFilter () {
      if (this.onValidateFilters()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/parametros_atendimento/TiposFinalizacao/components/search/search.js